import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { CTASectionBlock as CTASectionBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";

import styles from "./index.module.scss";

export const CtaSectionBlock = (
    block: Immutable<{ value: CTASectionBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.ctaSectionBlock,
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        <div className="main-container">
            <div>
                <a
                    className={concatClassNames([
                        styles.ctaSectionBuyButton,
                        "button",
                    ])}
                    href={block.value.button?.link?.url ?? ""}
                >
                    {block.value.button?.cta_text}
                </a>
                <div
                    className={concatClassNames([
                        styles.uBuyPricing,
                        styles.uBuyPricingNoTransform,
                    ])}
                    dangerouslySetInnerHTML={richHTML(block.value.copy)}
                />
            </div>
        </div>
    </section>
);
